import { api } from "./httpClient";

export const pricingRuleService = {
  list(propertyId, params = {}) {
    const query = new URLSearchParams();
    query.set("propertyId", propertyId);
    const isActive = params.isActive !== undefined && params.isActive !== null ? params.isActive : params.isEnabled;
    if (isActive !== undefined && isActive !== null) {
      query.set("isActive", isActive);
    }
    if (params.ruleType) query.set("ruleType", params.ruleType);
    if (params.q) query.set("q", params.q);
    if (params.page !== undefined) query.set("page", params.page);
    if (params.size !== undefined) query.set("size", params.size);
    const qs = query.toString();
    const url = "/v1/pricing-rules" + (qs ? "?" + qs : "");
    return api(url);
  },
  create(payload) {
    return api("/v1/pricing-rules", { method: "POST", body: JSON.stringify(payload) });
  },
  get(id, propertyId) {
    return api(`/v1/pricing-rules/${id}?propertyId=${encodeURIComponent(propertyId)}`);
  },
  update(id, payload, propertyId) {
    return api(`/v1/pricing-rules/${id}?propertyId=${encodeURIComponent(propertyId)}`, { method: "PUT", body: JSON.stringify(payload) });
  },
  remove(id, propertyId) {
    return api(`/v1/pricing-rules/${id}?propertyId=${encodeURIComponent(propertyId)}`, { method: "DELETE" });
  },
  listDates(pricingRuleId, params = {}) {
    const query = new URLSearchParams();
    query.set("pricingRuleId", pricingRuleId);
    const isActive = params.isActive !== undefined && params.isActive !== null ? params.isActive : params.isEnabled;
    if (isActive !== undefined && isActive !== null) {
      query.set("isActive", isActive);
    }
    if (params.q) query.set("q", params.q);
    if (params.page !== undefined) query.set("page", params.page);
    if (params.size !== undefined) query.set("size", params.size);
    const qs = query.toString();
    const url = "/v1/pricing-rule-dates" + (qs ? "?" + qs : "");
    return api(url);
  },
  createDate(payload) {
    return api("/v1/pricing-rule-dates", { method: "POST", body: JSON.stringify(payload) });
  },
  updateDate(id, payload, pricingRuleId) {
    return api(`/v1/pricing-rule-dates/${id}?pricingRuleId=${encodeURIComponent(pricingRuleId)}`, { method: "PUT", body: JSON.stringify(payload) });
  },
  removeDate(id, pricingRuleId) {
    return api(`/v1/pricing-rule-dates/${id}?pricingRuleId=${encodeURIComponent(pricingRuleId)}`, { method: "DELETE" });
  },
  listRooms(pricingRuleId, params = {}) {
    const query = new URLSearchParams();
    query.set("pricingRuleId", pricingRuleId);
    if (params.pricingMethod) query.set("pricingMethod", params.pricingMethod);
    if (params.page !== undefined) query.set("page", params.page);
    if (params.size !== undefined) query.set("size", params.size);
    const qs = query.toString();
    const url = "/v1/pricing-rule-rooms" + (qs ? "?" + qs : "");
    return api(url);
  },
  createRoom(payload) {
    return api("/v1/pricing-rule-rooms", { method: "POST", body: JSON.stringify(payload) });
  },
  updateRoom(id, payload, pricingRuleId) {
    return api(`/v1/pricing-rule-rooms/${id}?pricingRuleId=${encodeURIComponent(pricingRuleId)}`, { method: "PUT", body: JSON.stringify(payload) });
  },
  removeRoom(id, pricingRuleId) {
    return api(`/v1/pricing-rule-rooms/${id}?pricingRuleId=${encodeURIComponent(pricingRuleId)}`, { method: "DELETE" });
  },
  previewPrice(payload) {
    return api("/v1/bookings/price-preview", { method: "POST", body: JSON.stringify(payload) });
  },
};